/**
 * useOutreachOperation — progress of one durable batch operation
 * (send_initial / find_contacts) by its operation_id.
 *
 * SSE (outreach_operation_progress / outreach_operation_done, see
 * useOutreachSSE) is the primary path; the 2s poll below is the fallback for
 * a dropped stream and stops as soon as the operation leaves `running`.
 */
import { useQuery } from '@tanstack/react-query';
import type { OutreachOperation } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { fetchOutreachOperation } from '../api/outreachApi';

export const OUTREACH_OPERATION_POLL_MS = 2000;

export function useOutreachOperation(campaignId: string, operationId: string | null) {
  return useQuery<OutreachOperation>({
    queryKey: campaignKeys.outreachOperation(campaignId, operationId ?? ''),
    queryFn: () => fetchOutreachOperation(campaignId, operationId as string),
    enabled: !!operationId && !!campaignId,
    refetchInterval: (query) => (query.state.data?.status === 'running' ? OUTREACH_OPERATION_POLL_MS : false),
  });
}
